import { coachFetch } from "apps/user/learner/api/coach";
import {
  FeedbackState,
  FeedbackVote,
} from "apps/user/learner/pages/chat/types";

export interface MessageFeedbackInput {
  vote?: FeedbackVote;
  feedbackText?: string;
}

// Coach keys this endpoint on field *presence*: an omitted field is left alone, a null one is cleared.
export async function submitMessageFeedback(
  messageId: string,
  { vote, feedbackText }: MessageFeedbackInput
): Promise<FeedbackState> {
  const body: Record<string, unknown> = {};
  if (vote !== undefined) {
    body.vote = vote;
  }
  if (feedbackText !== undefined) {
    body.feedback_text = feedbackText === "" ? null : feedbackText;
  }

  const response = await coachFetch<FeedbackState | null>(
    `/api/messages/${messageId}/feedback/`,
    { method: "POST", body }
  );

  // A 204 means the write deleted the record, leaving nothing to report.
  return response ?? { vote: null, has_text: false };
}
